import { clientConfig } from '@/config'

const CLOUD_PROBE_TIMEOUT_MS = 5_000

/**
 * Check the desktop control-plane origin without requiring an authenticated
 * session. `navigator.onLine` only describes the network interface, so it
 * cannot detect a reachable network with an unavailable API.
 */
export async function probeDesktopCloud(): Promise<boolean> {
  try {
    // Health is mounted at the control-plane origin, not below the `/api`
    // application prefix used by authenticated product endpoints.
    const response = await fetch(`${clientConfig.apiOrigin}/health`, {
      cache: 'no-store',
      credentials: 'omit',
      headers: { Accept: 'application/json' },
      signal: AbortSignal.timeout(CLOUD_PROBE_TIMEOUT_MS),
    })
    return response.ok
  } catch {
    return false
  }
}
